// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取站内信息列表
export function userActivityList(token, data) {
  return request({
    url: "/api/user/activity_list",
    method: "post",
    data,
    headers: { token },
  });
}

// 学生报名信息修改
export function studentApplyUpdate(data) {
  return request({
    url: "/api/article/student_apply_update",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 学生报名详情
export function studentApplyInfo(data) {
  return request({
    url: "/api/article/student_apply_info",
    method: "post",
    data,
  });
}
